import {
  string as yupString,
  object as yupObject,
  date as yupDate,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import DatepickerFormik from '../../shared/forms/datepicker/rangeDatepickerFormik.component';

const schema = [
  {
    name: 'range',
    component: DatepickerFormik,
    options: { yupType: yupObject({ from: yupDate(), to: yupDate() }) },
    meta: { initialValue: {
      from: new Date(Date.now() - 86400000), // yesterday
      to: new Date(),
    } },
    additionalProps: {
      mode: 'showDoubleLargeCalendarWithRangePanel',
    },
  },
  {
    name: 'note',
    component: InputFormik,
    options: { yupType: yupString() },
    additionalProps: {
      placeholder: 'Note',
    },
  },
];

export default schema;
